var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAchTransfer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.72604 10.1417C3.56771 10.1417 3.40938 10.0834 3.28438 9.95842L2.27605 8.95007L1.26771 9.95842C1.02604 10.2001 0.626042 10.2001 0.384375 9.95842C0.142708 9.71675 0.142708 9.31676 0.384375 9.07509L1.83437 7.6251C2.07604 7.38343 2.47604 7.38343 2.71771 7.6251L4.16771 9.07509C4.40938 9.31676 4.40938 9.71675 4.16771 9.95842C4.05104 10.0834 3.88438 10.1417 3.72604 10.1417Z",
    fill: "#4F5372"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7175 12.5583C17.5591 12.5583 17.4008 12.4999 17.2758 12.3749L15.8258 10.9249C15.5841 10.6833 15.5841 10.2833 15.8258 10.0416C16.0674 9.79993 16.4675 9.79993 16.7091 10.0416L17.7175 11.05L18.7258 10.0416C18.9675 9.79993 19.3674 9.79993 19.6091 10.0416C19.8508 10.2833 19.8508 10.6833 19.6091 10.9249L18.1591 12.3749C18.0425 12.4916 17.8758 12.5583 17.7175 12.5583Z",
    fill: "#4F5372"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7161 12.5582C17.3744 12.5582 17.0911 12.2748 17.0911 11.9332V9.99984C17.0911 6.0915 13.9077 2.90816 9.99939 2.90816C7.84106 2.90816 5.82439 3.87483 4.46606 5.5665C4.24939 5.83317 3.85772 5.87483 3.59106 5.66649C3.32439 5.44983 3.27439 5.05817 3.49106 4.7915C5.08273 2.79984 7.45773 1.6665 9.99939 1.6665C14.5994 1.6665 18.3411 5.40818 18.3411 10.0082V11.9415C18.3411 12.2749 18.0661 12.5582 17.7161 12.5582Z",
    fill: "#4F5372"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99987 18.3414C5.39987 18.3414 1.6582 14.5997 1.6582 9.99975V8.06641C1.6582 7.72474 1.94154 7.44141 2.2832 7.44141C2.62487 7.44141 2.9082 7.72474 2.9082 8.06641V9.99975C2.9082 13.9081 6.09154 17.0914 9.99987 17.0914C12.1582 17.0914 14.1749 16.1248 15.5332 14.4331C15.7499 14.1664 16.1415 14.1164 16.4082 14.3331C16.6749 14.5498 16.7249 14.9414 16.5082 15.2081C14.9165 17.1997 12.5415 18.3414 9.99987 18.3414Z",
    fill: "#4F5372"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.13 6.57992L13.255 7.82991C13.3765 7.87852 13.4737 8.02435 13.4737 8.15282V9.3056C13.4737 9.49657 13.3175 9.65282 13.1265 9.65282H6.87652C6.68555 9.65282 6.5293 9.49657 6.5293 9.3056V8.15282C6.5293 8.02435 6.62652 7.87852 6.74805 7.82991L9.87305 6.57992C9.94249 6.55214 10.0605 6.55214 10.13 6.57992Z",
    stroke: "#4F5372",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4737 13.4724H6.5293V12.4307C6.5293 12.2397 6.68555 12.0835 6.87652 12.0835H13.1265C13.3175 12.0835 13.4737 12.2397 13.4737 12.4307V13.4724Z",
    stroke: "#4F5372",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.22266 12.0805V9.6499",
    stroke: "#4F5372",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07812 12.0805V9.6499",
    stroke: "#4F5372",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9336 12.0805V9.6499",
    stroke: "#4F5372",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7891 12.0805V9.6499",
    stroke: "#4F5372",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M6.18164 13.4722H13.8205",
    stroke: "#4F5372",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0013 8.78483C10.289 8.78483 10.5221 8.55165 10.5221 8.264C10.5221 7.97635 10.289 7.74316 10.0013 7.74316C9.71365 7.74316 9.48047 7.97635 9.48047 8.264C9.48047 8.55165 9.71365 8.78483 10.0013 8.78483Z",
    fill: "#4F5372"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAchTransfer);
export default __webpack_public_path__ + "static/media/ach-transfer.55ac50edd91caaaa05dab0ad073c0fa0.svg";
export { ForwardRef as ReactComponent };